const domain = function () {
  // SETANDO O OPERADOR PARA SER HOST (DB_NAME);
  const url = window.location.href.split("/");
  let op = "";
  if (url.indexOf("auth") != -1) {
    op = url.pop().split("?")[0];

    // Verifica se já existe um operador e o renova.
    const currentOp = localStorage.getItem("operator_auth");
    if (currentOp != null) {
      localStorage.removeItem("operator_auth");
      if (currentOp != op) {
        localStorage.setItem("operator_auth", op);
      }
    }

    localStorage.setItem("operator_auth", op);
  }

  // RECUPERANDO O HOST
  const hostName = window.location.hostname;
  let subdomain = hostName.split(".")[0];
  let domain = hostName.split(".")[1];
  let ext = hostName.split(".")[2];
  let host = subdomain == "www" || subdomain == "jogos" ? domain : subdomain;

  // Caso queira visualizar site em subdomínio de "demo" será necessário
  // configurar subdomínio no amplify e adicionar nos domínios permitidos abaixo
  const demoDomainsAllowed = {
    streetbet: "streetbet",
  };

  // DEVELOPMENT (Forçando o Host "Agent"):
  // host = 'agent'
  // host = 'dev'
  switch (host) {
    // Quando Agent retorna o db_name do operador.
    case "agent":
      op = localStorage.getItem("operator_auth");
      return op == "null" || op == null ? "Invalid_Operator" : op;
    // LocalHost: "sysbet" por padrão. Para simular outro operador, defina
    // VUE_APP_LOCAL_DOMAIN no .env.local (ex.: cartola).
    case "localhost":
    case "192":
      return process.env.VUE_APP_LOCAL_DOMAIN || "sysbet";
    case "casino":
      return "sysbet";
    case "sys":
      return "sysbet";
    // Clientes com 'db_name' diferente do Host (tratamento):
    case "demo":
      return demoDomainsAllowed[domain] ? demoDomainsAllowed[domain] : "";
    case "elitexbet":
      return ext === "com" ? "elitexbetcom" : "elitexbetnet";
    case "betinterativo":
      return ext === "com" ? "betinterativovip" : "betinterativo";
    case "superbets":
      return ext === "app" ? "superbetsapp" : "superbets";
    case "smilebet":
      return "smilebetnet";
    case "jogodeouro":
      return domain === "sga" ? "jogodeouro" : "jogodeourobet";
    case "zig":
      return "zigbet";
    case "statscore":
    case "datalayer":
    case "gtag":
    case "analytics":
    case "logo":
    case "thesports":
    case "recaptcha":
    case "homolog-api":
    case "lgaming":
      return "cartola";
    case "homolog-agent":
    case "homolog-user":
    case "homolog-user-newcasino":
      return "homolog";
    case "pixmaster":
      return "apostamaster";
    case "kbetsports":
      return "kbet";
    case "18k":
      return "18kbetonline";
    case "oxe":
      return "oxebet";
    case "topbetsonline":
      return "topbetsonlinecom";
    case "topbets":
      return ext === "live" ? "topbetslive" : "topbets";
    case "imperialbet":
      return ext === "com" ? "imperialbetcom" : "imperialbet";
    case "sonhobet":
      return ext === "com" ? "sonhobetcom" : "sonhobet";
    case "topsportsbet":
      return "topsports";
    // case "betdasorte":
    //   return "dasorte";
    case "trevopix":
      return "betpag";
    case "chutecerto":
      return ext === "io" ? "chutecertoio" : "chutecertopro";
    case "zero1bet":
      return "dubaibet";
    case "revybet":
      return "latano";
    case "spinbetsportes":
      return "spinbet";
    case "coraesporte":
      return "coraesportes";
    case "sullbetoff":
      return "sullbet";
    default:
      return host;
  }
};

export default domain;
